module.exports = __webpack_public_path__ + "static/media/zoom-in.29697f66.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/zoom-in.svg
// module id = 423
// module chunks = 0